import axios from 'axios'
import { toast } from '../components/ui/Toast'

// Catchall so a failed request always surfaces something to the user,
// even when a page's own error handling doesn't cover the response shape
// (e.g. no `error.response` at all because the server never responded).
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (!error.response) {
      toast.error("Can't reach the server. Check your connection and try again.", {
        details: `${error.config?.method?.toUpperCase()} ${error.config?.url}\n${error.message}`,
      })
    } else if (error.response.status >= 500) {
      toast.error('Something went wrong on our end. Please try again shortly.', {
        details: `${error.response.status} ${error.config?.method?.toUpperCase()} ${error.config?.url}\n${JSON.stringify(error.response.data)}`,
      })
    }
    return Promise.reject(error)
  }
)
